<template>
  <div class="box box-info">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      <Dialog header="Employee" :visible.sync="displayBasic"
              :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
            <label>Full Name<span style="color:red">*</span></label>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <InputText v-model.trim="firstName" id="firstName"/>
              <label for="firstName">First Name</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <span class="p-float-label">
            <InputText v-model.trim="middleName" id="middleName"/>
              <label for="middleName">Middle Name</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <InputText v-model.trim="lastName" id="lastName"/>
               <label for="lastName">Last Name</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="employeeId">Employee Id</label>
            <InputText v-model.trim="employeeNumber" id="employeeId"/>
          </div>
          <div class="p-field p-col-12 p-md-8"></div>
          <div class="p-field p-col-12 p-md-4">
            <label for="credentials">Create Login Details</label>
            <Checkbox v-model="createLogin" :binary="true" id="credentials" class="p-ml-5"/>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid" v-if="createLogin">
          <div class="p-field p-col-12 p-md-4">
             <span class="p-float-label">
              <InputText v-model.trim="username" id="username"/>
              <label for="username">User Name</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
             <span class="p-float-label">
              <Password v-model="password" id="newPassword" />
              <label for="newPassword">Password</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
             <span class="p-float-label">
              <InputText v-model.trim="confirmPassword" id="confirmPassword"/>
              <label for="confirmPassword">Confirm Password</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="userRole">User Role</label>
            <Dropdown v-model="role" :options="roleLists" optionLabel="name" placeholder="Select Role"
                     id="userRole"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="status">Status</label>
            <Dropdown v-model="status" :options="statusList" optionLabel="name" placeholder="Select Status"
                      id="status"/>
          </div>
        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="addEmployee"
                      :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
<!--      <employeeList />-->
    </form>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Checkbox from 'primevue/checkbox'
import Password from 'primevue/password'
import Dropdown from 'primevue/dropdown'
import employeeList from './employeeList.vue'
export default {
  name: 'createEmployee',
  data() {
    return {
      displayBasic: false,
      firstName: '',
      middleName: '',
      lastName: '',
      username: '',
      password: '',
      confirmPassword: '',
      employeeNumber: null,
      loading: false,
      editing: false,
      employeeId: null,
      deleteDialog: false,
      createLogin: false,
      role: {},
      status: {name: 'Enabled'},
      statusList: [{name: 'Enabled'}, {name: 'Disabled'}],
      filters: {}
    }
  },
  mounted() {
    this.findUserRole()
  },
  computed: {
    roleLists() {
      return this.$store.state.users.roleLists
    }
  },
  methods: {
    async findUserRole() {
      await this.$store.dispatch('loadRole')
    },
    async addEmployee() {
      if (this.firstName === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Employee Name cannot be empty!', life: 3000})
        return
      }
      if (this.employeeNumber === null) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Employee Id cannot be empty!', life: 3000})
        return
      }
      this.$router.push({name: 'employee Details', params: { employeeDetails: this.name }})
      let employee = {
        id: this.employeeId,
        value: this.name
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrMasterSetup', employee)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', employee)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    reset() {
      this.name = ''
      this.displayBasic = false
      this.createLogin = false
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancel() {
      this.displayBasic = false
      this.createLogin = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    Textarea,
    Checkbox,
    Password,
    Dropdown,
    employeeList
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// createEmployee.vue?e85fd552